import { SortRecordBy } from 'automation-ui-formula-editor/data-passing-panel/types/dataSourcesTypes';
import { AddDataSourceInitState } from 'automation-ui-formula-editor/fetch-object-panel/reducer/addDataSourceReducer';
import { RecordFilterTypes } from 'automation-ui-formula-editor/data-passing-panel/types/dataSourcesTypes';
import { SelectRecordBy } from 'automation-ui-formula-editor/fetch-object-panel/containers/fields/utils/selectRecordBy';
import { getFilterTargetType } from 'automation-ui-formula-editor/data-passing-panel/utils/getFilterTargetType';
export function getSortBy(metadata) {
  if ('sortBy' in metadata && metadata.sortBy) {
    return metadata.sortBy;
  } else if ('recordFilterDefinition' in metadata) {
    var _metadata$recordFilte;
    return (_metadata$recordFilte = metadata.recordFilterDefinition.sortBy) !== null && _metadata$recordFilte !== void 0 ? _metadata$recordFilte : null;
  }
  return null;
}
export function getSelectRecordBy(metadata) {
  if ('associationTimestampOrder' in metadata) {
    return metadata.associationTimestampOrder;
  } else {
    const sortBy = getSortBy(metadata);
    if ((sortBy === null || sortBy === void 0 ? void 0 : sortBy.property.toUpperCase()) === SortRecordBy.HS_LASTMODIFIEDDATE && (sortBy === null || sortBy === void 0 ? void 0 : sortBy.order) === 'DESC') {
      return SelectRecordBy.MOST_RECENTLY_UPDATED;
    } else if ((sortBy === null || sortBy === void 0 ? void 0 : sortBy.property.toUpperCase()) === SortRecordBy.HS_CREATEDATE) {
      if (sortBy.order === 'DESC') {
        return SelectRecordBy.MOST_RECENTLY_CREATED;
      } else {
        return SelectRecordBy.FIRST_CREATED;
      }
    }
  }
  return null;
}
export function convertDataSourceDefinitionToState(dataSourceDefinition) {
  const state = Object.assign({}, AddDataSourceInitState, {
    recordFilterDefinition: Object.assign({}, AddDataSourceInitState.recordFilterDefinition)
  });
  const metadata = dataSourceDefinition === null || dataSourceDefinition === void 0 ? void 0 : dataSourceDefinition.metadata;
  if (!metadata) {
    return state;
  }
  state.label = dataSourceDefinition.label;
  const recordFilterDefinition = state.recordFilterDefinition;
  recordFilterDefinition.selectRecordBy = getSelectRecordBy(metadata);
  recordFilterDefinition.filterTargetType = getFilterTargetType(metadata);
  if ('associationDefinition' in metadata) {
    const {
      associationId,
      associationDefinition
    } = metadata;
    state.objectTypeId = associationDefinition.toObjectTypeId;
    recordFilterDefinition.associationId = associationId;
    if ('associationTimestampOrder' in metadata) {
      recordFilterDefinition.recordFilterType = RecordFilterTypes.ASSOCIATION_TIMESTAMP;
      recordFilterDefinition.associationTimestampOrder = metadata.associationTimestampOrder;
    } else {
      recordFilterDefinition.recordFilterType = RecordFilterTypes.ASSOCIATION_LABEL;
    }
  } else if ('recordFilterDefinition' in metadata) {
    const {
      propertyName,
      matchingValue
    } = metadata.recordFilterDefinition;
    state.objectTypeId = metadata.objectTypeId;
    recordFilterDefinition.recordFilterType = RecordFilterTypes.MATCHING_PROPERTY;
    recordFilterDefinition.propertyName = propertyName;
    recordFilterDefinition.matchingValue = matchingValue;
  }
  return state;
}